<section class="page"><p role="status">Verificando su sesión…</p></section>
